function a(e) {
  if (e) return e.charAt(0).toUpperCase() + e.slice(1);
}
function t(e) {
  if (e) return e.toLowerCase().replace(/\S+/g, r => a(r));
}
function i(e) {
  var _e$trim$toLowerCase$m;
  if (e) return (_e$trim$toLowerCase$m = e.trim().toLowerCase().match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)) === null || _e$trim$toLowerCase$m === void 0 ? void 0 : _e$trim$toLowerCase$m.join("_");
}
function n(e) {
  return e == null || e == null ? !1 : e.trim() != "";
}
export { n as a, a as c, i as s, t };